
{
  "familyId": "STU-INHOUDSOPGAVE",
  "questions": [
    {
      "id": "STU-INHOUDSOPGAVE-001",
      "familyId": "STU-INHOUDSOPGAVE",
      "module": "Studievaardig",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_inhoudsopgave",
      "questionType": "multiple_choice",
      "question": "Waarvoor gebruik je een inhoudsopgave?",
      "context": null,
      "options": [
        "Om snel te zien welke onderwerpen in een boek staan en op welke pagina.",
        "Om de betekenis van moeilijke woorden op te zoeken.",
        "Om te zien wie het boek heeft geschreven.",
        "Om een samenvatting van het boek te lezen."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "inhoudsopgave_doel",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Een inhoudsopgave staat voorin een boek en laat zien welke hoofdstukken of onderwerpen erin staan, met de bijbehorende paginanummers. Zo kun je snel vinden wat je zoekt.",
        "distractorExplanations": {
          "0": "Correct! Een inhoudsopgave toont de onderwerpen en paginanummers.",
          "1": "Fout: voor de betekenis van woorden gebruik je een woordenlijst of woordenboek, niet de inhoudsopgave.",
          "2": "Fout: de naam van de schrijver staat op de voorkant of het titelblad, niet in de inhoudsopgave.",
          "3": "Fout: een samenvatting staat op de achterflap of in een apart hoofdstuk, niet in de inhoudsopgave."
        }
      }
    },
    {
      "id": "STU-INHOUDSOPGAVE-002",
      "familyId": "STU-INHOUDSOPGAVE",
      "module": "Studievaardig",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_inhoudsopgave",
      "questionType": "multiple_choice",
      "question": "Kijk naar de inhoudsopgave:\n\nHoofdstuk 1: Dieren in de jungle ......... 4\nHoofdstuk 2: Planten in de jungle ........ 12\nHoofdstuk 3: Het klimaat ................. 20\n\nOp welke pagina begint het hoofdstuk over planten?",
      "context": null,
      "options": ["Pagina 12", "Pagina 4", "Pagina 20", "Pagina 2"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "inhoudsopgave_paginanummer",
      "variantIndex": 2,
      "feedback": {
        "explanationText": "In de inhoudsopgave staat achter 'Planten in de jungle' het getal 12. Dat is het paginanummer waar dat hoofdstuk begint.",
        "distractorExplanations": {
          "0": "Correct! Hoofdstuk 2 over planten begint op pagina 12.",
          "1": "Fout: pagina 4 is het begin van hoofdstuk 1 (Dieren in de jungle), niet het plantenhoofstuk.",
          "2": "Fout: pagina 20 is het begin van hoofdstuk 3 (Het klimaat), niet het plantenhoofstuk.",
          "3": "Fout: pagina 2 staat niet in de inhoudsopgave. Het plantenhoofstuk begint op pagina 12."
        }
      }
    },
    {
      "id": "STU-INHOUDSOPGAVE-003",
      "familyId": "STU-INHOUDSOPGAVE",
      "module": "Studievaardig",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_inhoudsopgave",
      "questionType": "multiple_choice",
      "question": "Kijk naar de inhoudsopgave:\n\nHoofdstuk 1: De Middeleeuwen ............ 3\nHoofdstuk 2: Ridders en kastelen ........ 8\nHoofdstuk 3: Het dagelijks leven ........ 15\nHoofdstuk 4: Het einde van de Middeleeuwen .. 22\n\nHoeveel pagina's telt hoofdstuk 2 (van pagina 8 tot het begin van hoofdstuk 3)?",
      "context": null,
      "options": ["7 pagina's", "8 pagina's", "15 pagina's", "6 pagina's"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "inhoudsopgave_paginas_tellen",
      "variantIndex": 3,
      "feedback": {
        "explanationText": "Hoofdstuk 2 begint op pagina 8 en hoofdstuk 3 begint op pagina 15. Dus hoofdstuk 2 loopt van pagina 8 t/m pagina 14: 15 - 8 = 7 pagina's.",
        "distractorExplanations": {
          "0": "Correct! 15 - 8 = 7 pagina's (pagina 8 t/m 14).",
          "1": "Fout: je hebt het beginpaginanummer (8) als het aantal pagina's genomen. Het aantal pagina's is 15 - 8 = 7.",
          "2": "Fout: 15 is het paginanummer waar hoofdstuk 3 begint, niet het aantal pagina's van hoofdstuk 2.",
          "3": "Fout: controleer je berekening. Van pagina 8 tot pagina 15 zijn het 7 pagina's (8, 9, 10, 11, 12, 13, 14)."
        }
      }
    },
    {
      "id": "STU-INHOUDSOPGAVE-004",
      "familyId": "STU-INHOUDSOPGAVE",
      "module": "Studievaardig",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_inhoudsopgave",
      "questionType": "multiple_choice",
      "question": "Waar in een boek vind je de inhoudsopgave?",
      "context": null,
      "options": [
        "Voorin het boek, na de titelpagina",
        "Achterin het boek, na het laatste hoofdstuk",
        "In het midden van het boek",
        "Op de achterflap van het boek"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "inhoudsopgave_locatie",
      "variantIndex": 4,
      "feedback": {
        "explanationText": "De inhoudsopgave staat altijd voorin het boek, vlak na de titelpagina. Zo kun je meteen zien wat er in het boek staat voordat je begint te lezen.",
        "distractorExplanations": {
          "0": "Correct! De inhoudsopgave staat voorin het boek.",
          "1": "Fout: achterin het boek vind je soms een register (index) of woordenlijst. De inhoudsopgave staat voorin.",
          "2": "Fout: de inhoudsopgave staat niet in het midden. Die staat voorin het boek.",
          "3": "Fout: op de achterflap staat een korte beschrijving van het boek. De inhoudsopgave staat voorin."
        }
      }
    },
    {
      "id": "STU-INHOUDSOPGAVE-005",
      "familyId": "STU-INHOUDSOPGAVE",
      "module": "Studievaardig",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "informatie",
      "subSkill": "info_inhoudsopgave",
      "questionType": "multiple_choice",
      "question": "Je wilt iets weten over 'vulkanen'. Je hebt een boek over de aarde. Wat doe je als eerste?",
      "context": null,
      "options": [
        "Kijk in de inhoudsopgave of er een hoofdstuk over vulkanen is.",
        "Begin het boek van voren af aan te lezen.",
        "Sla het boek willekeurig open.",
        "Lees de achterflap."
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "inhoudsopgave_strategie",
      "variantIndex": 5,
      "feedback": {
        "explanationText": "Als je snel iets wilt vinden in een boek, kijk je eerst in de inhoudsopgave. Daar zie je meteen of er een hoofdstuk over vulkanen is en op welke pagina dat begint.",
        "distractorExplanations": {
          "0": "Correct! De inhoudsopgave is de snelste manier om te vinden wat je zoekt.",
          "1": "Fout: het hele boek lezen kost veel te veel tijd. Gebruik de inhoudsopgave om snel het juiste hoofdstuk te vinden.",
          "2": "Fout: willekeurig bladeren is niet efficiënt. Gebruik de inhoudsopgave.",
          "3": "Fout: de achterflap geeft een algemene beschrijving, maar niet de paginanummers van specifieke onderwerpen."
        }
      }
    }
  ]
}
